import * as Sentry from "@sentry/nextjs";

export function logCheckoutException(
  err: unknown,
  stage: string,
  extra?: Record<string, unknown>,
): string {
  return Sentry.withScope((scope) => {
    scope.setTag("checkout_stage", stage);
    if (extra) {
      scope.setContext("checkout", extra);
    }
    const details = err && typeof err === 'object'
      ? err as Record<string, unknown>
      : {};
    // Stripe.js returns plain error objects. Preserve useful diagnostics without
    // attaching payment methods, customer details or client secrets.
    const stripe: Record<string, string | number> = {};
    for (const key of ['type', 'code', 'decline_code', 'param', 'statusCode', 'status', 'requestId']) {
      const value = details[key];
      if (typeof value === 'string' || typeof value === 'number') stripe[key] = value;
    }
    if (Object.keys(stripe).length) scope.setContext('stripe', stripe);
    const exception = err instanceof Error ? err : new Error(
      typeof details.message === 'string' && details.message
        ? details.message
        : typeof err === 'string' ? err : 'Checkout error',
    );
    return Sentry.captureException(exception);
  });
}

export function logCheckoutIssue(
  message: string,
  stage: string,
  options?: {
    level?: "warning" | "error" | "info";
    extra?: Record<string, unknown>;
  },
): void {
  const level = options?.level ?? "warning";
  Sentry.withScope((scope) => {
    scope.setTag("checkout_stage", stage);
    scope.setLevel(level);
    if (options?.extra) {
      scope.setContext("checkout", options.extra);
    }
    Sentry.captureMessage(message, level);
  });
}
